import PropTypes from 'prop-types'

const LifeAndLegacyIcon = ({fill = 'currentColor', ...props}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={26}
    height={26}
    viewBox='374 394 452 410'
    fill='none'
    {...props}>
    <path
      fill={fill}
      d='m600 803.44-187.5-190.12c-23.324-23.055-36.82-54.246-37.66-87.031s11.043-64.625 33.16-88.844c12.977-13.453 28.895-23.723 46.5-30 25.957-8.5195 53.93-8.7305 80.012-0.59375 26.082 8.1328 48.977 24.203 65.488 45.969 16.477-21.652 39.273-37.652 65.238-45.781 25.969-8.1289 53.816-7.9883 79.699 0.40625 17.605 6.2773 33.523 16.547 46.5 30 22.188 24.148 34.172 55.945 33.438 88.73-0.73438 32.785-14.129 64.016-37.375 87.145zm-105-384.19c-11.5-0.003906-22.914 1.9609-33.75 5.8125-14.805 5.1875-28.215 13.723-39.188 24.938-18.863 20.688-28.953 47.887-28.148 75.871 0.80469 27.984 12.441 54.559 32.461 74.129l173.62 176.62 173.62-176.62c20.02-19.57 31.656-46.145 32.461-74.129 0.80469-27.984-9.2852-55.184-28.148-75.871-10.91-11.418-24.328-20.148-39.188-25.5-24.188-7.8867-50.332-7.3398-74.172 1.5508-23.836 8.8867-43.957 25.59-57.078 47.387l-7.875 12.375-7.875-12.375c-21.121-33.145-57.453-53.492-96.75-54.188z'
    />
  </svg>
)

LifeAndLegacyIcon.propTypes = {
  fill: PropTypes.string
}

export default LifeAndLegacyIcon
